import { render, staticRenderFns } from "./SfAccordionItem.vue?vue&type=template&id=14331150"
import script from "./SfAccordionItem.vue?vue&type=script&lang=js"
export * from "./SfAccordionItem.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfAccordionItem.vue?vue&type=style&index=0&id=14331150&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "e60a095c"
  
)

export default component.exports